import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { withRouter } from '../withRouter';
import ArticleCard from './ArticleCard';
import articlesService from '../../services/articles.service';
import styles from './ArticlesCategory.module.scss';

class ArticlesCategory extends Component {
    static displayName = ArticlesCategory.name;

    constructor(props) {
        super(props);
        this.state = {
            articles: [],
            category: null,
            page: 1,
            totalPages: 1,
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        const prevSlug = prevProps.params?.categorySlug;
        const currentSlug = this.props.params?.categorySlug;
        if (prevSlug !== currentSlug) {
            this.setState({ page: 1 }, () => this.loadData());
        }
    }

    loadData = async () => {
        const categorySlug = this.props.params?.categorySlug;
        if (!categorySlug) return;

        this.setState({ loading: true, error: null });
        try {
            const [articlesResult, categories] = await Promise.all([
                articlesService.getArticles({ categorySlug, page: this.state.page, pageSize: 12 }),
                articlesService.getCategories()
            ]);

            const category = categories.find(c => c.slug === categorySlug) || null;

            this.setState({
                articles: articlesResult.articles || [],
                totalPages: articlesResult.totalPages || 1,
                category,
                loading: false,
            });
        } catch (e) {
            console.error('[ArticlesCategory] Error loading:', e);
            this.setState({ error: 'Failed to load articles', loading: false });
        }
    }

    onPageChange = (newPage) => {
        this.setState({ page: newPage }, () => {
            this.loadData();
            window.scrollTo(0, 0);
        });
    }

    render() {
        const { articles, category, page, totalPages, loading } = this.state;
        const categorySlug = this.props.params?.categorySlug;

        const seoTitle = category?.metaTitle || category?.name || categorySlug;
        const seoDescription = category?.metaDescription || category?.description || '';

        return (
            <React.Fragment>
                <Helmet>
                    <title>{seoTitle} | Articles | Game City</title>
                    <meta name="robots" content="index, follow" />
                    {seoDescription && <meta name="description" content={seoDescription} />}
                </Helmet>
                <div className={styles.articlesCategory}>
                    <div className={styles.cloudBG} />
                    <Container>
                        <Link to="/articles" className={styles.breadcrumb}>&#8592; All Articles</Link>

                        <h1 className={styles.pageTitle}>{category?.name || categorySlug}</h1>
                        {category?.description && (
                            <p className={styles.description}>{category.description}</p>
                        )}

                        {loading ? (
                            <div className={styles.loadingText}>Loading articles...</div>
                        ) : articles.length === 0 ? (
                            <div className={styles.emptyText}>No articles in this category yet.</div>
                        ) : (
                            <>
                                <Row className={styles.grid}>
                                    {articles.map(article => (
                                        <Col xs={12} md={6} lg={4} key={article.id} className={styles.gridItem}>
                                            <ArticleCard article={article} />
                                        </Col>
                                    ))}
                                </Row>

                                {totalPages > 1 && (
                                    <div className={styles.pagination}>
                                        <button
                                            className={`${styles.button} ${styles.small} ${styles.alternate}`}
                                            disabled={page <= 1}
                                            onClick={() => this.onPageChange(page - 1)}
                                        >
                                            Previous
                                        </button>
                                        <span className={styles.pageInfo}>Page {page} of {totalPages}</span>
                                        <button
                                            className={`${styles.button} ${styles.small} ${styles.alternate}`}
                                            disabled={page >= totalPages}
                                            onClick={() => this.onPageChange(page + 1)}
                                        >
                                            Next
                                        </button>
                                    </div>
                                )}
                            </>
                        )}

                        <div className={styles.backSection}>
                            <Link to="/articles" className={`${styles.button} ${styles.small} ${styles.alternate}`}>Back to All Articles</Link>
                        </div>
                    </Container>
                    <div className={styles.cityScape} />
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, null)(withRouter(ArticlesCategory));
